import React from "react";
import { ClockCircleOutlined, RocketOutlined } from "@ant-design/icons";

function DashBoards() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950">
      
      {/* Background Glow */}
      <div className="absolute rounded-full top-[-120px] left-[-120px] h-72 w-72 bg-blue-500/20 blur-3xl" />
      <div className="absolute rounded-full bottom-[-140px] right-[-100px] h-80 w-80 bg-cyan-400/20 blur-3xl" />
      <div className="absolute w-56 h-56 rounded-full top-1/3 right-1/4 bg-indigo-500/10 blur-3xl" />

      {/* Grid Overlay */}
      <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,0.08)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.08)_1px,transparent_1px)] bg-[size:40px_40px]" />

      {/* Main Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-12">
        <div className="w-full max-w-3xl border shadow-2xl bg-white/10 backdrop-blur-xl rounded-3xl border-white/10">
          
          {/* Top Badge */}
          <div className="flex justify-center pt-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold tracking-wide text-blue-100 border rounded-full bg-white/10 border-white/10">
              <ClockCircleOutlined />
              Page Under Development
            </div>
          </div>

          {/* Content */}
          <div className="px-8 py-12 text-center md:px-14">
            <div className="flex items-center justify-center w-24 h-24 mx-auto mb-8 border shadow-lg rounded-3xl bg-gradient-to-br from-blue-500 to-cyan-400 border-white/10">
              <RocketOutlined className="text-4xl text-white" />
            </div>

            <h1 className="text-4xl font-extrabold tracking-tight text-white md:text-6xl">
              Coming Soon
            </h1>

            <p className="max-w-2xl mx-auto mt-5 text-base leading-7 md:text-lg text-slate-300">
              We’re currently building this page to deliver a smoother, more
              powerful experience. Please check back soon for updates.
            </p>

            {/* Divider */}
            <div className="w-24 h-1 mx-auto mt-8 rounded-full bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-500" />

            {/* Status Cards */}
            <div className="grid grid-cols-1 gap-4 mt-10 md:grid-cols-3">
              <div className="p-5 text-left border rounded-2xl bg-white/5 border-white/10">
                <p className="text-xs font-semibold tracking-[0.18em] uppercase text-slate-400">
                  Status
                </p>
                <h3 className="mt-2 text-lg font-bold text-white">
                  In Progress
                </h3>
              </div>

              <div className="p-5 text-left border rounded-2xl bg-white/5 border-white/10">
                <p className="text-xs font-semibold tracking-[0.18em] uppercase text-slate-400">
                  Experience
                </p>
                <h3 className="mt-2 text-lg font-bold text-white">
                  Professional UI
                </h3>
              </div>

              <div className="p-5 text-left border rounded-2xl bg-white/5 border-white/10">
                <p className="text-xs font-semibold tracking-[0.18em] uppercase text-slate-400">
                  Availability
                </p>
                <h3 className="mt-2 text-lg font-bold text-white">
                  Launching Soon
                </h3>
              </div>
            </div>

            {/* Footer Text */}
            <p className="mt-10 text-sm text-slate-400">
              Thank you for your patience while we prepare this section.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashBoards;